module.exports = __webpack_public_path__ + "static/media/phone.091246e7.svg";